import {Table} from 'antd';

export const CogsPurchaseOrderLineItemTable = ({products, props}) => {

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                const purchaseOrder = record.purchaseOrder;
                const {purchaseId, id: lineId} = purchaseOrder;
                const onClick = () => {
                    window.open(`/purchaseorder/${purchaseId}/lineItem/${lineId}`, `_blank`);
                }
                // return <Link to={`/purchaseorder/${purchaseId}/lineItem/${lineId}`}>{val}</Link>
                return <div onClick={onClick} style={{cursor: 'pointer', color: "#108ee9"}}>{val}</div>
            }
        },
        {
            title: '# Requested',
            dataIndex: 'quantityRequested',
            key: 'quantityRequested',
            render: (val, record) => {
                // quantity is the amount requested in the PO, quantityCreated is what was actually created
                const {quantity} = record.purchaseOrder;
                return `${quantity}`;
            }
        },
        {
            title: 'Quantity',
            dataIndex: 'quantityCreated',
            key: 'quantityCreated',
            render: (val, record) => {
                // quantity is the amount requested in the PO, quantityCreated is what was actually created
                const {quantityCreated} = record.purchaseOrder;
                return `${quantityCreated}`;
            }
        },
        {
            title: 'Wholesale Cost',
            dataIndex: 'purchaseOrder',
            key: 'wholesaleCost',
            render: (val, record, index) => {
                const {wholesaleCost} = record.purchaseOrder;
                return `$ ${wholesaleCost}`
            }
        },
        {
            title: 'Supply Cost',
            dataIndex: 'purchaseOrder',
            key: 'supplyCost',
            render: (val, record, index) => {
                const {supplyCost} = record.purchaseOrder;
                return `$ ${supplyCost}`
            }
        },
        {
            title: 'Testing Cost',
            dataIndex: 'purchaseOrder',
            key: 'testingCost',
            render: (val, record, index) => {
                const {testingCost} = record.purchaseOrder;
                return `$ ${testingCost}`
            }
        },
        {
            title: 'Labor Cost',
            dataIndex: 'purchaseOrder',
            key: 'laborCost',
            render: (val, record, index) => {
                const {laborCost} = record;
                return `$ ${laborCost}`
            }
        },
        {
            title: 'Total Cost',
            dataIndex: 'totalCost',
            key: 'totalCost',
            render: (val, record, index) => {
                return `$ ${val}`;
            }
        }
    ];


    return <Table dataSource={products} columns={columns} pagination={false} />
}